export const expertRegistration = {
  // Account Type Selection
  'expert.accountType.title': 'Welcome to subvention360!',
  'expert.accountType.subtitle': 'How would you like to use our platform?',
  'expert.accountType.user.title': 'User',
  'expert.accountType.user.description': 'I\'m looking for funding for myself, my company, or my clients',
  'expert.accountType.user.feature1': 'AI-powered intelligent search',
  'expert.accountType.user.feature2': 'Personalized recommendations',
  'expert.accountType.user.feature3': 'Application tracking',
  'expert.accountType.user.cta': 'Sign up as user',
  
  'expert.accountType.expert.title': 'Advisor Directory',
  'expert.accountType.expert.description': 'I want to be listed on the platform so future clients can find me and I can help them',
  'expert.accountType.expert.feature1': 'Free registration',
  'expert.accountType.expert.feature2': 'Directory listing',
  'expert.accountType.expert.feature3': 'Visibility to potential clients',
  'expert.accountType.expert.cta': 'Join the advisor directory',
  'expert.accountType.alreadyHaveAccount': 'Already registered?',
  'expert.accountType.login': 'Sign in',
  
  // Registration Wizard
  'expert.registration.title': 'Advisor Registration',
  'expert.registration.subtitle': 'Create your advisor profile in minutes',
  'expert.registration.step1': 'Company',
  'expert.registration.step2': 'Expertise',
  'expert.registration.step3': 'Certifications',
  'expert.registration.step4': 'Geography',
  'expert.registration.step5': 'Profile',
  'expert.registration.step6': 'Summary',
  'expert.registration.step7': 'Account',
  'expert.registration.next': 'Next',
  'expert.registration.previous': 'Previous',
  'expert.registration.submit': 'Create Account',
  
  // Wizard UI
  'expertRegistration.wizard.title': 'Advisor Registration',
  'expertRegistration.wizard.subtitle': 'Join our directory of subsidy advisors',
  'expertRegistration.wizard.progress': 'Step {{current}} of {{total}}',
  'expertRegistration.steps.company': 'Company',
  'expertRegistration.steps.expertise': 'Expertise',
  'expertRegistration.steps.certifications': 'Certifications',
  'expertRegistration.steps.geographic': 'Geography',
  'expertRegistration.steps.profile': 'Profile',
  'expertRegistration.steps.summary': 'Review',
  'expertRegistration.steps.auth': 'Account',
  'expertRegistration.buttons.continue': 'Continue',
  'expertRegistration.buttons.back': 'Back',
  'expertRegistration.buttons.submit': 'Create Account',
  'expertRegistration.buttons.add': 'Add',
  
  // Field labels
  'expertRegistration.fields.email': 'Email Address',
  'expertRegistration.fields.password': 'Password',
  'expertRegistration.fields.confirmPassword': 'Confirm Password',
  'expertRegistration.fields.companyName': 'Company Name',
  'expertRegistration.fields.siren': 'SIREN',
  'expertRegistration.fields.siret': 'SIRET',
  'expertRegistration.fields.contactEmail': 'Contact Email',
  'expertRegistration.fields.contactPhone': 'Contact Phone',
  'expertRegistration.fields.websiteUrl': 'Website',
  'expertRegistration.fields.expertiseAreas': 'Expertise Areas',
  'expertRegistration.fields.customExpertise': 'Custom Expertise Area',
  'expertRegistration.fields.specializations': 'Specializations',
  'expertRegistration.fields.customSpecialization': 'Custom Specialization',
  'expertRegistration.fields.certifications': 'Certifications',
  'expertRegistration.fields.customCertification': 'Custom Certification',
  'expertRegistration.fields.headquarters': 'Headquarters',
  'expertRegistration.fields.headquartersRegion': 'Region',
  'expertRegistration.fields.headquartersDepartment': 'Department',
  'expertRegistration.fields.serviceCoverage': 'Service Coverage',
  'expertRegistration.fields.selectRegions': 'Select Regions',
  'expertRegistration.fields.selectEUCountries': 'Select EU Countries',
  'expertRegistration.fields.selectCountries': 'Select Countries',
  'expertRegistration.fields.remoteServices': 'Remote services available',
  'expertRegistration.fields.yearsExperience': 'Years of Experience',
  'expertRegistration.fields.teamSize': 'Team Size',
  'expertRegistration.fields.languages': 'Languages',
  'expertRegistration.fields.bio': 'Professional Bio',
  'expertRegistration.fields.engagementModels': 'Engagement Models',
  
  // Placeholders
  'expertRegistration.placeholders.companyName': 'ABC Consulting',
  'expertRegistration.placeholders.search': 'Search...',
  'expertRegistration.placeholders.searchCertifications': 'Search certifications...',
  'expertRegistration.placeholders.customExpertise': 'e.g., Blockchain & Web3',
  'expertRegistration.placeholders.customSpecialization': 'e.g., AI/ML Implementation',
  'expertRegistration.placeholders.customCertification': 'e.g., ISO 27001',
  'expertRegistration.placeholders.selectRegion': 'Select a region',
  'expertRegistration.placeholders.selectDepartment': 'Select a department',
  'expertRegistration.placeholders.bio': 'Describe your experience and approach...',
  
  // Help texts
  'expertRegistration.help.siren': '9-digit company identification number',
  'expertRegistration.help.siret': '14-digit establishment identification number',
  'expertRegistration.help.expertiseAreas': 'Select {{min}} to {{max}} areas of expertise',
  'expertRegistration.help.specializations': 'Select {{min}} to {{max}} specializations',
  'expertRegistration.help.certifications': 'Select {{min}} to {{max}} certifications',
  'expertRegistration.help.serviceCoverage': 'Select all coverage areas that apply to your services',
  'expertRegistration.help.profileOptional': 'These fields are optional but help clients understand your expertise',
  
  // Summary section titles
  'expertRegistration.summary.companyInfo': 'Company Information',
  'expertRegistration.summary.expertise': 'Expertise',
  'expertRegistration.summary.certifications': 'Certifications',
  'expertRegistration.summary.geographic': 'Geographic Coverage',
  'expertRegistration.summary.professionalProfile': 'Professional Profile',
  
  // Common
  'expertRegistration.optional': 'optional',
  'expertRegistration.years': 'years',
  
  'expertRegistration.terms.accept': 'I accept the terms and conditions',
  'expertRegistration.terms.link': 'View terms',
  
  // Validation
  'expertRegistration.validation.companyNameRequired': 'Company name is required',
  'expertRegistration.validation.sirenInvalid': 'SIREN must be exactly 9 digits',
  'expertRegistration.validation.siretInvalid': 'SIRET must be exactly 14 digits',
  'expertRegistration.validation.emailInvalid': 'Please enter a valid email address',
  'expertRegistration.validation.urlInvalid': 'Please enter a valid URL',
  'expertRegistration.validation.passwordMin': 'Password must be at least 8 characters',
  'expertRegistration.validation.passwordUppercase': 'Password must contain at least one uppercase letter',
  'expertRegistration.validation.passwordLowercase': 'Password must contain at least one lowercase letter',
  'expertRegistration.validation.passwordNumber': 'Password must contain at least one number',
  'expertRegistration.validation.passwordMismatch': 'Passwords do not match',
  'expertRegistration.validation.expertiseRange': 'Please select between 3 and 5 areas of expertise',
  'expertRegistration.validation.specializationsRange': 'Please select between 2 and 5 specializations',
  'expertRegistration.validation.certificationsRange': 'Please select between 1 and 10 certifications',
  
  // Password Strength
  'expertRegistration.passwordStrength.title': 'Password Requirements',
  'expertRegistration.passwordStrength.minLength': 'At least 8 characters',
  'expertRegistration.passwordStrength.uppercase': 'One uppercase letter',
  'expertRegistration.passwordStrength.lowercase': 'One lowercase letter',
  'expertRegistration.passwordStrength.number': 'One number',
  
  // Common
  'common.loading': 'Loading...',
  'common.back': 'Back',
  
  // Step 1: Auth
  'expert.auth.emailLabel': 'Professional email',
  'expert.auth.emailPlaceholder': 'your@email.com',
  'expert.auth.passwordLabel': 'Password',
  'expert.auth.passwordPlaceholder': 'Minimum 6 characters',
  'expert.auth.confirmPasswordLabel': 'Confirm password',
  'expert.auth.termsLabel': 'I accept the terms and conditions',
  'expert.auth.termsRequired': 'You must accept the terms',
  
  // Step 2: Company Info
  'expert.company.title': 'Company Information',
  'expert.company.subtitle': 'Provide your company details',
  'expert.company.nameLabel': 'Company name',
  'expert.company.namePlaceholder': 'ABC Consulting',
  'expert.company.nameRequired': 'Company name is required',
  'expert.company.sirenLabel': 'SIREN (9 digits)',
  'expert.company.sirenPlaceholder': '123456789',
  'expert.company.sirenInvalid': 'SIREN must be exactly 9 digits',
  'expert.company.siretLabel': 'SIRET (14 digits)',
  'expert.company.siretPlaceholder': '12345678900012',
  'expert.company.siretInvalid': 'SIRET must be exactly 14 digits',
  'expert.company.emailLabel': 'Contact email',
  'expert.company.phoneLabel': 'Phone',
  'expert.company.phonePlaceholder': '+33 1 23 45 67 89',
  'expert.company.websiteLabel': 'Website',
  'expert.company.websitePlaceholder': 'https://www.example.com',
  'expert.company.websiteInvalid': 'Please enter a valid URL',
  
  // Step 3: Expertise
  'expert.expertise.title': 'Areas of Expertise',
  'expert.expertise.subtitle': 'Select your areas of competence (minimum 3)',
  'expert.expertise.areasLabel': 'Main expertise areas',
  'expert.expertise.areasPlaceholder': 'Search for an area...',
  'expert.expertise.areasMin': 'Select at least 3 areas',
  'expert.expertise.areasMax': 'Maximum 5 areas',
  'expert.expertise.specializationsLabel': 'Specializations',
  'expert.expertise.specializationsPlaceholder': 'Search for a specialization...',
  'expert.expertise.specializationsMin': 'Select at least 2 specializations',
  'expert.expertise.specializationsMax': 'Maximum 5 specializations',
  'expert.expertise.customLabel': 'Specify (if "Other" selected)',
  'expert.expertise.customPlaceholder': 'E.g.: Blockchain & Web3',
  'expert.expertise.customRequired': 'Please specify your area',
  'expert.expertise.customMinLength': 'Minimum 3 characters',
  
  // Step 4: Certifications
  'expert.certifications.title': 'Certifications & Accreditations',
  'expert.certifications.subtitle': 'Add your professional certifications (minimum 1)',
  'expert.certifications.label': 'Certifications',
  'expert.certifications.placeholder': 'Search for a certification...',
  'expert.certifications.min': 'Select at least 1 certification',
  'expert.certifications.max': 'Maximum 10 certifications',
  'expert.certifications.categoryEnergy': 'Energy & Environment',
  'expert.certifications.categoryConstruction': 'Construction & Building',
  'expert.certifications.categoryQuality': 'Quality & Standards',
  'expert.certifications.categoryFinance': 'Finance',
  'expert.certifications.categoryBusiness': 'Business & Enterprise',
  'expert.certifications.categoryTraining': 'Training',
  'expert.certifications.categoryEuropean': 'European',
  'expert.certifications.categoryOther': 'Other',
  
  // Step 5: Geographic
  'expert.geographic.title': 'Service Area',
  'expert.geographic.subtitle': 'Define your geographic coverage',
  'expert.geographic.headquartersTitle': 'Headquarters',
  'expert.geographic.regionLabel': 'Headquarters region',
  'expert.geographic.regionPlaceholder': 'Select a region',
  'expert.geographic.regionRequired': 'Region is required',
  'expert.geographic.departmentLabel': 'Department',
  'expert.geographic.departmentPlaceholder': 'E.g.: 75, 92, 93',
  'expert.geographic.coverageTitle': 'Service coverage',
  'expert.geographic.scopeLabel': 'Geographic scope',
  'expert.geographic.scopeRequired': 'Scope is required',
  'expert.geographic.regionsLabel': 'Covered regions',
  'expert.geographic.regionsPlaceholder': 'Select regions',
  'expert.geographic.departmentsLabel': 'Covered departments',
  'expert.geographic.departmentsPlaceholder': 'E.g.: 75, 92, 93',
  'expert.geographic.remoteLabel': 'Remote services available',
  'expert.geographic.countriesLabel': 'Covered countries',
  'expert.geographic.countriesPlaceholder': 'Select countries',
  
  // Step 6: Professional Profile
  'expert.profile.title': 'Professional Profile',
  'expert.profile.subtitle': 'Additional information (optional)',
  'expert.profile.experienceLabel': 'Years of experience',
  'expert.profile.experiencePlaceholder': '0-50',
  'expert.profile.teamSizeLabel': 'Team size',
  'expert.profile.teamSizePlaceholder': '1-1000',
  'expert.profile.languagesLabel': 'Languages spoken',
  'expert.profile.languagesPlaceholder': 'Select languages',
  'expert.profile.bioLabel': 'Biography / Presentation',
  'expert.profile.bioPlaceholder': 'Describe your experience and approach...',
  'expert.profile.bioMaxLength': 'Maximum 500 characters',
  'expert.profile.engagementLabel': 'Engagement models',
  'expert.profile.engagementHourly': 'Hourly rate',
  'expert.profile.engagementFixed': 'Fixed fee',
  'expert.profile.engagementSuccess': 'Success fee',
  'expert.profile.engagementRetainer': 'Retainer',
  'expert.profile.engagementProBono': 'Pro bono',
  
  // Step 7: Summary
  'expert.summary.title': 'Summary',
  'expert.summary.subtitle': 'Review your information before submitting',
  'expert.summary.companySection': 'Company',
  'expert.summary.expertiseSection': 'Expertise',
  'expert.summary.certificationsSection': 'Certifications',
  'expert.summary.geographicSection': 'Geography',
  'expert.summary.profileSection': 'Professional Profile',
  'expert.summary.edit': 'Edit',
  'expert.summary.customBadge': 'Custom',
  'expert.summary.headquartersLabel': 'Headquarters',
  'expert.summary.coverageLabel': 'Coverage',
  'expert.summary.remoteAvailable': 'Remote services',
  'expert.summary.experienceYears': 'years experience',
  'expert.summary.teamMembers': 'members',
  
  // Success Page
  'expert.success.title': 'Advisor profile created successfully!',
  'expert.success.subtitle': 'Your request has been submitted',
  'expert.success.pendingTitle': 'Pending verification',
  'expert.success.pendingDescription': 'Your profile is being reviewed by our team. You will receive an email within 48 hours to confirm your listing.',
  'expert.success.nextStepsTitle': 'In the meantime, you can:',
  'expert.success.explorePlatform': 'Explore the platform',
  'expert.success.explorePlatformDescription': 'Discover how users search for subsidies',
  'expert.success.createUserProfile': 'Create a user profile',
  'expert.success.createUserProfileDescription': 'Test subsidy search for your own projects',
  'expert.success.returnHome': 'Return home',
  
  // Auth Step
  'expertRegistration.auth.directoryTitle': 'Join Our Advisor Directory',
  'expertRegistration.auth.directoryDescription': 'By completing this registration, you will be listed in our advisor directory where potential clients can find and contact you for subsidy assistance.',
  'expertRegistration.auth.createUserAccount': 'Also create a user account to explore subsidies',
  'expertRegistration.auth.userAccountBenefit': 'You will be able to use the platform to search for subsidies for yourself or your clients',
  
  // Validation Messages
  'expert.validation.required': 'This field is required',
  'expert.validation.emailInvalid': 'Invalid email address',
  'expert.validation.passwordMismatch': 'Passwords do not match',
  'expert.validation.passwordTooShort': 'Password must be at least 6 characters',
  'expert.validation.minSelection': 'Minimum selection not reached',
  'expert.validation.maxSelection': 'Maximum selection exceeded',
  'expert.validation.urlInvalid': 'Invalid URL',
  'expert.validation.phoneInvalid': 'Invalid phone number',
  
  // Error Messages
  'expert.error.submissionFailed': 'Submission failed',
  'expert.error.submissionFailedDescription': 'An error occurred. Please try again.',
  'expert.error.authFailed': 'Authentication error',
  'expert.error.emailAlreadyExists': 'This email is already in use',
  'expert.error.networkError': 'Connection error. Check your internet connection.',
} as const;
